/**
 * Component added when room changes are finished.
 * @implements {Component}
 *
 * @property {number} typeId - The unique identifier for this component type
 * @property {boolean} doStoreInSnapshot - Flag indicating if component should be stored in snapshots
 *
 * @example
 * const roomChangeFinished = new RoomChangeCompleteComponent();
 */
class RoomChangeCompleteComponent {
    constructor() {
        this.typeId = RoomChangeCompleteComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
RoomChangeCompleteComponent.id = 3000;
export default RoomChangeCompleteComponent;
//# sourceMappingURL=RoomChangeCompleteComponent.js.map